import React from 'react';
import { OrderDetail } from '../components/orders/OrderDetail';

const OrderDetailPage = () => {
  return <OrderDetail />;
};

export default OrderDetailPage;
